module.exports = __webpack_public_path__ + "static/img/2_2_3_2.3f6fb7c1.jpg";